<div class="future-plan">
  <div class="row middle-xs between-xs">
    <div class="col-no-gutter">
      <h4 class="future-plan__title">{{label}}</h4>
    </div>
    <ng-container *ngIf="!readonly">
      <div class="col-sm-3 col-no-gutter">
        <mfp-button
          class="future-plan__remove"
          color="secondary"
          [fill]="removeFill"
          [size]="removeSize"
          [icon]="removeIcon"
          [iconPosition]="removeIconPosition"
          [label]="removeLabel"
          (click)="remove()"
        ></mfp-button>
      </div>
    </ng-container>

  </div>
  <div [formGroup]="form">
    <div class="row row-xs--no-margin">
      <div class="col-xs-24 col-sm-6 col-gutter-lr">
        <mfp-select
          view="agent"
          [name]="goalTypeName"
          [formControlName]="goalTypeName"
          [label]="goalTypeLabel"
          [color]="goalTypeColor"
          [options]="goalTypeOptions"
          [placeholder]="goalTypePlaceholder"
          [required]="false"
          [readonly]="false"
          [success]="isFieldValid(form, goalTypeName)"
          [error]="isFieldInvalid(form, goalTypeName)"
          [helper]="getFieldError(form, goalTypeName) | translate"
          [readonly]="readonly"
          [required]="required"
        ></mfp-select>
      </div>
      <div class="col-xs-24 col-sm-9 col-gutter-lr">
        <mfp-input-currency
          type="text"
          view="agent"
          [name]="goalAmountName"
          [formControlName]="goalAmountName"
          [label]="goalAmountLabel"
          [currencyOptions]="currencyOptions"
          [success]="isFieldValid(form, goalAmountName)"
          [error]="isFieldInvalid(form, goalAmountName)"
          [helper]="getFieldError(form, goalAmountName) | translate"
          [readonly]="readonly"
          [required]="required"
        ></mfp-input-currency>
      </div>
      <div class="col-xs-24 col-sm-9 col-gutter-lr">
        <mfp-input-currency
          type="text"
          view="agent"
          [name]="assuredAmountName"
          [formControlName]="assuredAmountName"
          [label]="assuredAmountLabel"
          [currencyOptions]="currencyOptions"
          [success]="isFieldValid(form, assuredAmountName)"
          [error]="isFieldInvalid(form, assuredAmountName)"
          [helper]="getFieldError(form, assuredAmountName) | translate"
          [readonly]="readonly"
          [required]="required"
        ></mfp-input-currency>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-24 col-xs--no-margin col-sm-6 col-gutter-lr">
        <mfp-input
          type="number"
          view="agent"
          [name]="dateName"
          [formControlName]="dateName"
          [label]="dateLabel"
          [placeholder]="datePlaceholder"
          [success]="isFieldValid(form, dateName)"
          [error]="isFieldInvalid(form, dateName)"
          [helper]="getFieldError(form, dateName) | translate:dateErrorData"
          [readonly]="readonly"
          [required]="required"
        ></mfp-input>
      </div>
      <!-- This div is used to apply horizontal paddding since there is only one element on this row -->
      <div></div>
    </div>
  </div>
</div>
